<div class="layout-menu mt-4">
  <ul>
    <ng-container *ngFor="let item of navigationItems; index as i">
      <li
        *ngIf="item as navItem"
        [ngClass]="{ 'sub-item-open': subMenuOpened === i }"
        routerLinkActive="active"
      >
        <a [routerLink]="[navItem.route]" routerLinkActive="active">
          <div class="icon"><i [class]="navItem.iconClass"></i></div>
          <div class="text">{{ navItem.label }}</div>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
